import React from "react";
import {
  SaveOutlined,
  ClearOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Tooltip } from "antd";
import "../css/form-card.css";
import { FormCardProps, SectionProps } from "../interfaces";

export const FormCard: React.FC<FormCardProps> = ({
  title,
  subtitle,
  icon,
  badge,
  isProcessing,
  onSave,
  onClear,
  formId,
  hideActions,
  children,
  maxWidth = 460,
}) => {
  return (
    <div className="fc-page">
      <div className="fc-card" style={{ maxWidth}}>
        {/* ── Header ── */}
        <div className="fc-header">
          <div className="fc-header-icon">{icon}</div>

          <div style={{ flex: 1, minWidth: 0 }}>
            <p className="fc-title">{title}</p>
            {subtitle && <p className="fc-subtitle">{subtitle}</p>}
          </div>

          {badge?.show && (
            <span className="fc-badge">
              <span className="fc-badge-dot" />
              {badge.label}
            </span>
          )}

          {/* Acciones */}
          {!hideActions && (
            <div className="fc-header-actions">
              {onClear && (
                <Tooltip title="Limpiar">
                  <button
                    type="button"
                    className="fc-btn fc-btn-clear"
                    disabled={isProcessing}
                    onClick={onClear}
                  >
                    <ClearOutlined />
                  </button>
                </Tooltip>
              )}
              <Tooltip title="Guardar">
                <button
                  type={formId ? "submit" : "button"}
                  form={formId}
                  className="fc-btn fc-btn-save"
                  disabled={isProcessing}
                  onClick={formId ? undefined : onSave}
                >
                  {isProcessing ? <LoadingOutlined spin /> : <SaveOutlined />}
                </button>
              </Tooltip>
            </div>
          )}
        </div>

        {/* ── Body ── */}
        <div className="fc-body">{children}</div>
      </div>
    </div>
  );
};

/* ── FormSection — separador con etiqueta ───────────────────────────────── */
export const FormSection: React.FC<SectionProps> = ({ label, children }) => (
  <div className="fc-section">
    <p className="fc-section-label">{label}</p>
    <hr className="fc-divider" />
    <div className="fc-section-content">{children}</div>
  </div>
);

/* ── FormRow — dos campos en fila ───────────────────────────────────────── */
export const FormRow: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div className="fc-row">{children}</div>;
